import {
    containerFluid,
    defaultFont,
    primaryColor,
    defaultBoxShadow,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    whiteColor,
    grayColor,
} from "assets/jss/material-dashboard-pro-react.js";

const headerStyle = () => ({
    appBar: {
        boxShadow: "none !important",
        borderBottom: "0",
        marginBottom: "0",
        position: "relative !important",
        width: "100%",
        paddingTop: "4px",
        color: 'infoColor',
        border: "0",
        transition: "all 150ms ease 0s",
        minHeight: "42px",
        background: "rgba(0, 0, 0, 0) !important",
        fontWeight: "bolder"
    },
    container: {
        minHeight: "34px !important",
        display: "inline",
        width: "100%",
        padding: "0px !important",
        maxHeight: "34px"
    },
    flex: {
        flex: 0.3,
        width: "10%",
        display: "inline",
        verticalAlign: "top"
    },
    title: {
        width: "95%",
        margin: "auto",
        letterSpacing: "unset",
        lineHeight: "25px",
        fontSize: "18px",
        borderRadius: "3px",
        textTransform: "none",
        color: "inherit",
        "&:hover,&:focus": {
            background: "transparent"
        }
    },
    appResponsive: {
        top: "8px"
    },
    primary: {
        backgroundColor: primaryColor[0],
        color: whiteColor,
        ...defaultBoxShadow,
    },
    info: {
        backgroundColor: infoColor[0],
        color: whiteColor,
        ...defaultBoxShadow,
    },
    success: {
        backgroundColor: successColor[0],
        color: whiteColor,
        ...defaultBoxShadow,
    },
    warning: {
        backgroundColor: warningColor[0],
        color: whiteColor,
        ...defaultBoxShadow,
    },
    danger: {
        backgroundColor: dangerColor[0],
        color: whiteColor,
        ...defaultBoxShadow,
    },
    sidebarMinimize: {
        float: "left",
        padding: "0 0 0 15px",
        display: "block",
        color: grayColor[6],
    },
    sidebarMinimizeRTL: {
        padding: "0 15px 0 0 !important",
    },
    sidebarMiniIcon: {
        width: "20px",
        height: "17px",
    },
});

export default headerStyle;
